var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgHyperlinkUnlink = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      enableBackground: "new 0 0 24 24"
    },
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0",
    id: "grid"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,12c0,3.032,2.467,5.5,5.5,5.5h4c0.276,0,0.5-0.224,0.5-0.5s-0.224-0.5-0.5-0.5h-4C3.019,16.5,1,14.481,1,12   s2.019-4.5,4.5-4.5h4C9.776,7.5,10,7.276,10,7S9.776,6.5,9.5,6.5h-4C2.467,6.5,0,8.968,0,12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5,6.5h-4C14.224,6.5,14,6.724,14,7s0.224,0.5,0.5,0.5h4c2.481,0,4.5,2.019,4.5,4.5s-2.019,4.5-4.5,4.5h-4   c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5h4c3.033,0,5.5-2.468,5.5-5.5S21.533,6.5,18.5,6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,3c0.276,0,0.5-0.224,0.5-0.5v-2C12.5,0.224,12.276,0,12,0s-0.5,0.224-0.5,0.5v2C11.5,2.776,11.724,3,12,3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.519,3.707c0.128,0,0.256-0.049,0.354-0.146c0.195-0.195,0.195-0.512,0-0.707L6.458,1.439   c-0.195-0.195-0.512-0.195-0.707,0s-0.195,0.512,0,0.707l1.414,1.414C7.263,3.658,7.391,3.707,7.519,3.707z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.835,3.561l1.414-1.414c0.195-0.195,0.195-0.512,0-0.707s-0.512-0.195-0.707,0l-1.414,1.414   c-0.195,0.195-0.195,0.512,0,0.707c0.098,0.098,0.226,0.146,0.354,0.146S16.737,3.658,16.835,3.561z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,23.5c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5v-2c0-0.276-0.224-0.5-0.5-0.5s-0.5,0.224-0.5,0.5V23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.165,20.439l-1.414,1.414c-0.195,0.195-0.195,0.512,0,0.707c0.098,0.098,0.226,0.146,0.354,0.146   s0.256-0.049,0.354-0.146l1.414-1.414c0.195-0.195,0.195-0.512,0-0.707S7.36,20.244,7.165,20.439z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.896,22.707c0.128,0,0.256-0.049,0.354-0.146c0.195-0.195,0.195-0.512,0-0.707l-1.414-1.414   c-0.195-0.195-0.512-0.195-0.707,0s-0.195,0.512,0,0.707l1.414,1.414C17.64,22.658,17.768,22.707,17.896,22.707z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHyperlinkUnlink);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hyperlink_unlink.f723434f7487c0d9b56003e02ffbe6e0.svg";